module.exports = __webpack_public_path__ + "a37a4a28bf0d54ade85e217f849ae850.pdf";